/* RESPONSIBLE TEAM: team-actions */
export const showFinTaskSimpleMode = (app: any, editorState: any, isTemplatePreview: boolean) => {
  return (
    editorState.isFinTaskSimpleMode &&
    (app.canUseFinTaskSimpleMode ||
      (app.canShowFinTaskSimpleModeInTemplatePreview && isTemplatePreview))
  );
};
